export const baseURL = '/api/rest/s1';
